module.exports = __webpack_public_path__ + "static/media/icon-plane.841809c0.svg";